<router-outlet></router-outlet>

<p-confirmDialog
  header="Confirmation"
  key="confirmation"
  icon="pi pi-exclamation-triangle"
  message="Sure? this action can't be reverted!"
  [style]="{ width: '350px' }"
  acceptButtonStyleClass="p-button-text p-button-danger"
  rejectButtonStyleClass="p-button-text p-button-secondary"
></p-confirmDialog>

<p-toast></p-toast>
